export default __webpack_public_path__ + "static/media/preview.ea1c2125.png";